// Superscript Popover System
(function() {
    'use strict';

    let activePopover = null;
    let activeRef = null;

    // Initialize the popover system
    function initPopovers() {
        // Add click handlers to all superscript references
        const refs = document.querySelectorAll('sup[data-ref]');
        refs.forEach(ref => {
            ref.addEventListener('click', handleRefClick);
        });

        // Add global click handler to close popovers
        document.addEventListener('click', handleDocumentClick);

        // Handle window resize to reposition active popover
        window.addEventListener('resize', () => {
            if (activePopover && activeRef) {
                positionPopover(activePopover, activeRef);
            }
        });

        // Handle scroll to reposition active popover
        window.addEventListener('scroll', () => {
            if (activePopover && activeRef) {
                positionPopover(activePopover, activeRef);
            }
        }, true);
    }

    // Handle clicking on a reference
    function handleRefClick(e) {
        e.stopPropagation();
        const ref = e.currentTarget;

        // If clicking the active reference, close it
        if (activeRef === ref) {
            closePopover();
            return;
        }

        // Close any existing popover
        closePopover();

        // Create and show new popover
        const popover = createPopover(ref);
        document.body.appendChild(popover);
        
        // Position the popover
        positionPopover(popover, ref);

        // Activate after a brief delay for animation
        setTimeout(() => {
            popover.classList.add('active');
        }, 10);

        // Update active states
        activePopover = popover;
        activeRef = ref;
        ref.classList.add('active');
    }

    // Create a popover element
    function createPopover(ref) {
        const popover = document.createElement('div');
        popover.className = 'ref-popover';
        
        const title = ref.getAttribute('data-title') || 'Reference';
        const source = ref.getAttribute('data-source') || '#';
        
        popover.innerHTML = `
            <div class="ref-popover-title">${escapeHtml(title)}</div>
            <a href="${escapeHtml(source)}" class="ref-popover-link" target="_blank" rel="noopener noreferrer">
                ${escapeHtml(source)}
            </a>
        `;

        // Prevent clicks inside popover from closing it
        popover.addEventListener('click', e => e.stopPropagation());

        return popover;
    }

    // Position the popover relative to the reference
    function positionPopover(popover, ref) {
        const refRect = ref.getBoundingClientRect();
        const popoverRect = popover.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const scrollX = window.pageXOffset;
        const scrollY = window.pageYOffset;

        // Calculate initial position (centered above the reference)
        let left = refRect.left + scrollX + (refRect.width / 2) - (popoverRect.width / 2);
        let top = refRect.top + scrollY - popoverRect.height - 10;

        // Check if popover would go above viewport
        if (refRect.top - popoverRect.height - 10 < 0) {
            // Position below instead
            top = refRect.bottom + scrollY + 10;
            popover.classList.add('above');
        } else {
            popover.classList.remove('above');
        }

        // Adjust horizontal position if it would go outside viewport
        if (left < 10) {
            left = 10;
        } else if (left + popoverRect.width > viewportWidth - 10) {
            left = viewportWidth - popoverRect.width - 10;
        }

        popover.style.left = `${left}px`;
        popover.style.top = `${top}px`;
    }

    // Close the active popover
    function closePopover() {
        if (activePopover) {
            const popoverToRemove = activePopover;
            activePopover.classList.remove('active');
            setTimeout(() => {
                popoverToRemove.remove();
            }, 200);
        }
        if (activeRef) {
            activeRef.classList.remove('active');
        }
        activePopover = null;
        activeRef = null;
    }

    // Handle clicks outside of references and popovers
    function handleDocumentClick(e) {
        if (!e.target.closest('sup[data-ref]') && !e.target.closest('.ref-popover')) {
            closePopover();
        }
    }

    // Escape HTML to prevent XSS
    function escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPopovers);
    } else {
        initPopovers();
    }
})();